import React, { Component } from 'react';
import styled from 'styled-components';

import { Layout } from 'antd';
import { AccionesNav } from './AccionesNav';
import { Banner } from './Banner';
import { UserNav } from './UserNav';

const Header = styled(Layout.Header)`
    width: 100%;
    background: white !important;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    padding: 0 40px !important;
    z-index: 1;
`;

const HeaderContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    max-width: 1200px;
    margin: auto;
    height: 100%;
`;

export class AppHeader extends Component {
    render() {
        return (
            <Header>
                <HeaderContentWrapper>
                    <Banner />
                    <AccionesNav />
                    <UserNav />
                </HeaderContentWrapper>
            </Header>
        );
    }
}
